import React, { forwardRef } from "react";
import DataFetcher from "../DataFetcher/DataFetcher";
import { Swiper, SwiperSlide } from "swiper/react"; // Import Swiper and SwiperSlide
import "swiper/css"; // Core Swiper styles
import "swiper/css/effect-fade"; // Effect Fade styles
import "swiper/css/navigation"; // Navigation styles
import "swiper/css/pagination"; // Pagination styles
import "swiper/css/autoplay"; // Autoplay styles
import { EffectFade, Navigation, Autoplay, Pagination } from "swiper/modules"; // Import modules from swiper/modules
import { Link } from "react-router-dom";

const ArchitectureSlider = forwardRef((props, ref) => {
const API_URL = `${process.env.REACT_APP_API_BASE_URL}?op=enchilada`;

  return (
    <DataFetcher url={API_URL}>
      {(data) => {
        return (
          <section className="pt-0 pb-0" id="home" ref={ref}>
            <div className="slider-bg flexslider">
              <ul className="slides">
                <Swiper
                  modules={[EffectFade, Navigation, Autoplay, Pagination]} // Pass modules as props
                  pagination={{ clickable: true }}
                  navigation
                  loop={true}
                  grabCursor={true}
                  effect={"fade"}
                  autoplay={{ delay: 7000 }}
                  observer={true}
                  observeParents={true}
                >
                  {data.properties
                    .filter(
                      (property) =>
                        property.Status === "A" &&
                        property.featured === "1" &&
                        property.PropertyType === "S"
                    )
                    .map((property) => (
                      <SwiperSlide key={property.WebId}>
                        <Link to={`/property/${property.WebId}`}>
                          <div
                            className="slide-img"
                            style={{
                              backgroundImage: `url(${process.env.REACT_APP_IMAGE_BASE_URL}${property.WebId}/large1.jpg)`,
                              backgroundPosition: "center center",
                              backgroundSize: "cover",
                              backgroundRepeat: "no-repeat",
                              backgroundAttachment: "scroll",
                              
                            
                            }}
                            
                          ></div>
                          <div
                            className={
                              "hero-text-wrap " +
                              (property.bg
                                ? "gradient-overlay-bg"
                                : "gradient-overlay-bg")
                            }
                          >
                            <div className="hero-text white-color">
                              <div className="container text-center">
                                <h3 className="white-color font-400 letter-spacing-5 text-uppercase">
                                  {property.Address2 ? property.Address2 : ""}
                                </h3>
                                <h3 className="white-color font-700">
                                  {property.ListingInfo
                                    ? property.ListingInfo
                                    : ""}
                                </h3>
                                <h4 className="white-color font-700">
                                  {property.Price
                                    ? new Intl.NumberFormat("en-US", {
                                        style: "currency",
                                        currency: "USD",
                                        maximumFractionDigits: 0,
                                        minimumFractionDigits: 0,
                                      }).format(property.Price)
                                    : ""}
                                </h4>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </SwiperSlide>
                    ))}
                </Swiper>
              </ul>
            </div>
          </section>
        );
      }}
    </DataFetcher>
  );
});

export default ArchitectureSlider;
